// @ts-check

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Accordion from '../../custom/Accordion';
import AccordionSummary from '../../custom/AccordionSummary';
import AccordionDetails from '../../custom/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import useFormStyles from '../../common/FormStyle';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Button from '@material-ui/core/Button';
import SelectMaterial from './helpers/SelectMaterial';
import materialsDictionary from '../../../assets/materials_dictionary.json';
import sheetDictionary from '../../../assets/sheet_dictionary.json';

import {
  SET_MATERIALS_DIALOG_OPEN,
  SET_MATERIAL
} from '../../../redux/actions/actionTypes'

function Materials(props) {
  const formStyles = useFormStyles();
  const sustainabilityState = useSelector(state => state.globalFormData.sustainability);
  const dispatch = useDispatch()
  const allMaterials = sustainabilityState.materials

  function handleChange_open(id, open_or_close) {
    return function (event) {
      dispatch({
        type: SET_MATERIALS_DIALOG_OPEN,
        payload: {
          id,
          open: open_or_close === "open" ? true : false
        }
      })
    }
  }

  function getTileUrl(materialId) {
    const materialArrays = Object.values(materialsDictionary)
    for (const materialsArray of materialArrays) {
      const matchingMaterialObj = materialsArray.find(m => m[0] === materialId)
      if (matchingMaterialObj) {
        return matchingMaterialObj[1].tile_url
      }
    }
  }

  // Handle change for changing the material
  function handleChange_material(elem) {
    const id = elem.id
    return function (value) {
      const material = allMaterials.find(m => m.id === id)
      material.material = value
      material.open = false
      material.tile_url = getTileUrl(value)

      dispatch({
        type: SET_MATERIAL,
        payload: {
          id,
          material
        }
      })
    }
  }

  const [expanded, setExpanded] = useState(false);
  const handleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <Accordion expanded={expanded} onChange={handleExpanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon fontSize="small" />}
        aria-controls="Sustainability-content"
        id="Sustainability-header"
        IconButtonProps={{
          className: formStyles.expandButton
        }}
      >
        <Typography className={clsx(formStyles.accordionSubheader, formStyles.bold)}>Materials & Embodied CO₂</Typography>

      </AccordionSummary>

      <AccordionDetails>
        <Box className={clsx(formStyles.w100)}>
          <Typography className={clsx(formStyles.accordionTitle, formStyles.bold)} color="textSecondary">
            Select build-ups and construction materials
          </Typography>
          <Box>
            {allMaterials.map((elem) => (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                key={elem.id}
              >
                <Typography className={clsx(formStyles.accordionTitle, formStyles.bold, formStyles.margin2)}>
                  {elem.element}
                </Typography>

                <Box>
                  <Button
                    color="default"
                    endIcon={<NavigateNextIcon />}
                    onClick={handleChange_open(elem.id, "open")}
                  >
                    {elem.material ? sheetDictionary[elem.material] : "-----"}
                  </Button>

                  <SelectMaterial
                    onClose={handleChange_open(elem.id, "close")}
                    open={elem.open}
                    onSelect={handleChange_material(elem)}
                    elements={materialsDictionary[elem.sheetName]}
                    sheetName={elem.sheetName}
                  />
                </Box>
              </Box>
            ))}
          </Box>

        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default Materials